import { Injectable } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import {
  ApiModels,
  filteredData,
  peaksChartObj,
} from '@reenstudio/app/core/models/charts/peaks-model';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class PeaksChartService {
  public chartOptions: Partial<ApexOptions>;

  filteredData: filteredData[] = [];

  getPeaksData(data: ApiModels, peaksChartObj: peaksChartObj) {
    this.filteredData = [];

    let sortDate = data.values.sort(
      (a, b) => new Date(a.hour).getTime() - new Date(b.hour).getTime()
    );

    let lastDate = sortDate[0];
    this.filteredData.push(lastDate);

    for (let i = 1; i < sortDate.length; i++) {
      const currentDate = sortDate[i];

      const minutesDifference =
        (new Date(currentDate.hour).getTime() -
          new Date(lastDate.hour).getTime()) /
        (1000 * 60);

      if (minutesDifference >= 15) {
        this.filteredData.push(currentDate);
        lastDate = currentDate;
      }
    }

    for (let el of this.filteredData) {
      peaksChartObj.prodotto.push(el.production);

      peaksChartObj.consumato.push(el.consumption);

      peaksChartObj.produzionePicco.push(el.production_peak);

      peaksChartObj.consumatoPicco.push(el.consumption_peak);
    }

    for (let value of this.filteredData) {
      peaksChartObj.ore.push(new Date(value.hour).getHours());
    }

    this.removeDuplicatesAndReplace(peaksChartObj);

    for (let ora of peaksChartObj.ore) {
      if (ora != '') {
        peaksChartObj.formattedHours.push(format(ora, ora + ':00'));
      } else {
        peaksChartObj.formattedHours.push('');
      }
    }

    peaksChartObj.series = [
      {
        name: 'ProduzionePicco',
        data: peaksChartObj.produzionePicco,
        type: 'scatter',
        color: '#137333',
      },
      {
        name: 'ConsumatoPicco',
        data: peaksChartObj.consumatoPicco,
        type: 'scatter',
        color: '#004582',
      },
      {
        name: 'Prodotto',
        data: peaksChartObj.prodotto,
        type: 'area',
        color: '#26E7A6',
      },
      {
        name: 'Consumato',
        data: peaksChartObj.consumato,
        type: 'area',
        color: '#26A0FC',
      },
    ];

    return peaksChartObj;
  }

  removeDuplicatesAndReplace(peaksChartObj: peaksChartObj) {
    peaksChartObj.ore = peaksChartObj.ore.map(
      (item: any, index: any, arr: any) => {
        if (arr.indexOf(item) !== index) {
          return '';
        }
        return item;
      }
    );
  }

  setPeaksChart(peaksChartObj: peaksChartObj): Partial<ApexOptions> {
    this.chartOptions = {
      series: peaksChartObj.series,
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [0, 1],
      },
      markers: {
        size: [4, 4, 0, 0],
        showNullDataPoints: false,
        fillOpacity: 1,
        colors: ['#137333', '#004582'],
        strokeColors: ['#137333', '#004582'],
      },
      stroke: {
        curve: 'smooth',
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 1,
        },
      },
      xaxis: {
        categories: peaksChartObj.formattedHours,
        labels: {
          show: true,
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return (+val / 1000).toFixed(1) + 'kW';
          },
        },
      },
    };

    return this.chartOptions;
  }

  getInitObj() {
    return {
      consumato: [],
      prodotto: [],
      consumatoPicco: [],
      produzionePicco: [],
      ore: [],
      formattedHours: [],
      series: [],
    };
  }
}
